import { render, staticRenderFns } from "./OrderProductSupplierProduct.vue?vue&type=template&id=1fe175ef&scoped=true&"
import script from "./OrderProductSupplierProduct.vue?vue&type=script&lang=js&"
export * from "./OrderProductSupplierProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe175ef",
  null
  
)

export default component.exports